import { j as f } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as x, useState as N, useEffect as j } from "react";
import { c as v } from "./tw-cn-mXgPecoF.mjs";
import { c as m } from "./index-BpNK5r1N.mjs";
const R = m([
  "relative inline-block h-32 w-52 p-2 rounded-full group",
  "transition-colors duration-200 ease-in-out",
  "bg-fill-neutral-weak3 aria-checked:bg-fill-neutral-main",
  "disabled:bg-interaction-neutral-disable-main disabled:cursor-not-allowed disabled:opacity-30",
  "disabled:aria-checked:bg-interaction-neutral-disable-main"
]), A = m([
  "absolute left-2 top-2 size-28 rounded-full bg-static-white shadow-3 ",
  "transition-transform duration-200 ease-in-out group-aria-checked:translate-x-20"
]), D = x((d, b) => {
  const { className: h, style: w, checked: a, disabled: s, onChange: e, onKeyDown: o, onClick: l, ...p } = d, [n, u] = N(a ?? d.defaultChecked ?? !1), k = R(), g = A(), c = (t, i) => {
    if (a !== void 0)
      return e == null || e(t, i), t;
    let r = n;
    return s || (r = t, u(r), e == null || e(r, i)), r;
  }, y = (t) => {
    t.key === "ArrowLeft" ? c(!1, t) : t.key === "ArrowRight" && c(!0, t), o == null || o(t);
  }, S = (t) => {
    const i = c(!n, t);
    l == null || l(i, t);
  };
  return j(() => {
    s || u(!!a);
  }, [a, s]), /* @__PURE__ */ f.jsx(
    "button",
    {
      ...p,
      "aria-checked": n,
      className: v(k, h),
      disabled: s,
      onClick: S,
      onKeyDown: y,
      ref: b,
      role: "switch",
      style: w,
      type: "button",
      children: /* @__PURE__ */ f.jsx("span", { className: g })
    }
  );
});
D.displayName = "NDS.Switch";
export {
  D as S
};
